<template>
    <card-tabs v-if="showSmartMarketingCard" selected-name="realworks">
        <template #labels>
            <card-tab-label
                v-if="showRealworksTab"
                name="realworks"
                class="card-tab-label-custom"
            >
                <icon-realworks
                    class="realworks-icon"
                />
            </card-tab-label>

            <card-tab-label
                v-if="showActiveCampaignTab"
                name="activeCampaign"
                class="card-tab-label-custom"
            >
                <icon-active-campaign />
            </card-tab-label>
        </template>

        <template #panels>
            <card-tab-panel
                v-if="showRealworksTab"
                name="realworks"
            >
                <realworks-content />
            </card-tab-panel>

            <card-tab-panel
                v-if="showActiveCampaignTab"
                name="activeCampaign"
            >
                <active-campaign-content />
            </card-tab-panel>
        </template>
    </card-tabs>
</template>

<script setup lang="ts">
    import { ref, provide, computed, reactive } from 'vue';
    import { CardTabs, CardTabLabel, CardTabPanel } from '@keyvue/one-ui';
    import RealworksContent from '@views/Contact/Detail/Cards/SmartMarketing/RealworksContent.vue';
    import ActiveCampaignContent from '@views/Contact/Detail/Cards/SmartMarketing/ActiveCampaignContent.vue';
    import IconRealworks from '@assets/icons/smartMarketing/Realworks.svg?component';
    import IconActiveCampaign from '@assets/icons/smartMarketing/ActiveCampaign.svg?component';
    import { RealworksAPI } from '@keyvue/one-api-client-legacy';
    import { Contact } from '@keyvue/one-api-client';
    import useClient from '@composables/useClient';

    interface Props {
        contactId: string;
    }

    const props = defineProps<Props>();
    const { client } = useClient();

    const contact = reactive(await client.get(Contact, props.contactId)) as Contact;
    provide('contact', contact);

    const showRealworksTab = ref(false);
    const realworksContactInformation = ref(null);
    const loadRealworksData = async () => {
        try {
            realworksContactInformation.value = await RealworksAPI.getContactInformation(props.contactId);
            showRealworksTab.value = true;
        } catch (error) {
            showRealworksTab.value = false;
        }
    };

    const showActiveCampaignTab = ref(false);
    const showSmartMarketingCard = computed(() => showRealworksTab.value || showActiveCampaignTab.value);

    provide('realworksContactInformation', realworksContactInformation);

    await loadRealworksData();
</script>

<style scoped lang="scss">
.card-tab-label-custom {
    padding-top: size(xs) !important;
}

.realworks-icon {
    height: 12px;
}
</style>
